export default __webpack_public_path__ + "static/main2-46576c3729b9950e4f416a5d65aab5d9.jpg";